module.exports = __webpack_public_path__ + "static/img/mini-bus-orange.d37f712.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/mini-bus-orange.svg
// module id = QFBp
// module chunks = 74